import React from 'react'

export default function Footer() {
  return <>
    <footer class="footer" id="footer">
        <div class="container-fluied">
          <span>Copy Right 2024 © By Eslam All Rights Reserved</span>
        </div>
  
      </footer>
  </>
}
